export default __webpack_public_path__ + "static/media/spinner.1b9b66f1.gif";